<div class="sunburst-content">
    <ng-container>
        <h4 *ngIf="isDetailsVisible">{{ showedLabel }}</h4>
        <h4 *ngIf="!isDetailsVisible">{{mainPartition.partitionDetails.text?.shortLabel}}</h4>
    </ng-container>

    <div class="sunburst" #sunburst>
        <ng-container *ngIf="mainPartition">
            <div *ngIf="isDetailsVisible" class="part-details">
                <div class="part-percent">{{ showedPercent }}</div>
                <div class="part-value">{{ showedValue | formatAmount: 'auto' }}</div>
            </div>
            <div *ngIf="!isDetailsVisible" class="part-general">
                <div class="part-value">{{ mainPartition.simulationValues.amount | formatAmount: 'auto' }}</div>
            </div>
        </ng-container>
    </div>
</div>

<mat-list class="partitions-list" *ngIf="selectedNodes && selectedNodes.length">
    <mat-list-item *ngFor="let selected of selectedNodes; index as i">
        <span class="label" [ngStyle]="{color: colors[i]}">{{ selected.partitionDetails.text.shortLabel }}</span>
        <span class="amount">{{ selected.simulationValues.amount | formatAmount: 'auto'  }}</span>
    </mat-list-item>
</mat-list>
